import { lazy } from "react";
import { useRoutes } from "react-router-dom";

const Main = lazy(() => import("pages/Main"));
const SendAppeal = lazy(() => import("pages/SendAppeal"));
const GetAppeals = lazy(() => import("pages/GetAppeals"));
const FAQ = lazy(() => import("pages/FAQ"));
const AppealsList = lazy(() => import("pages/AppealsList"));
const SingleAppeal = lazy(() => import("pages/SingleAppeal"));
const Icons = lazy(() => import("pages/Icons"));
const NotFound = lazy(() => import("pages/NotFound"));
const Unauthenticated = lazy(() => import("pages/Unauthenticated"));
const SendAppealForm = lazy(() => import("pages/SendAppealForm"));
const RegisterForm = lazy(() => import("pages/RegisterForm"));
export default function RoutesList() {
	return useRoutes([
		{ path: "/", element: <Main /> },
		{ path: "/main/send-appeals", element: <Main /> },
		{ path: "/main/faq", element: <Main /> },
		{ path: "/main/about-platform", element: <Main /> },
		{ path: "/main/use-platform", element: <Main /> },
		{ path: "/send-appeal", element: <SendAppeal /> },
		{ path: "/send-appeal/form", element: <SendAppealForm /> },
		{ path: "/get-appeals", element: <GetAppeals /> },
		{ path: "/appeals-list", element: <AppealsList /> },
		{ path: "/appeals-list/:id", element: <SingleAppeal /> },
		{ path: "/faq", element: <FAQ /> },
		{ path: "/unauthenticated", element: Unauthenticated },
		{ path: "/component/icons", element: <Icons /> },
		{ path: "/register", element: <RegisterForm /> },
		{ path: "*", element: <NotFound /> }
	]);
}
